
import { DeviceDetailActions, DeviceDetailActionTypes } from '../actions/device-detail.actions';
import {DeviceMgtDetail} from '../device-mgt.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: DeviceMgtDetail;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(state = initialState, action: DeviceDetailActions): State {
  switch (action.type) {
    case DeviceDetailActionTypes.GetDeviceDetails:
      return {...state, Loaded: false, Loading: true};

    case DeviceDetailActionTypes.LoadDeviceDetails:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case DeviceDetailActionTypes.GetDeviceDetailsFail:
      return {...state, Loaded: true, Loading: false, entities: null};

    default:
      return state;
  }
}
